// REDUCERS ------------------------------------------------------------------------------------------------------------
export const REDUCER = {
  ACCOUNT: {
    FETCHING: 'ACCOUNT_FETCHING',
    NEW_PASSWORD_SENT: 'ACCOUNT_NEW_PASSWORD_SENT',
    SET_NEW_USER_DATA: 'ACCOUNT_SET_NEW_USER_DATA',
    SET_UPDATED_USER: 'ACCOUNT_SET_UPDATED_USER',
    SET_USER_PICTURE: 'ACCOUNT_SET_USER_PICTURE',
    SET_IS_AVATAR_MODAL_OPEN: 'ACCOUNT_SET_IS_AVATAR_MODAL_OPEN',
    SET_SELECTED_AVATAR: 'ACCOUNT_SET_SELECTED_AVATAR',
    SET_USER_DATA: 'ACCOUNT_SET_USER_DATA',
    SET_USER_LANGUAGE: 'ACCOUNT_SET_USER_LANGUAGE',
    SET_REFRESH_MODAL_STATE: 'ACCOUNT_SET_REFRESH_MODAL_STATE',
    ADD_REQUEST_TOKEN_SUBSCRIBER: 'ACCOUNT_ADD_REQUEST_TOKEN_SUBSCRIBER',
    SET_IS_ALREADY_FETCHING_TOKEN: 'ACCOUNT_SET_IS_ALREADY_FETCHING_TOKEN',
    LOGOUT: 'ACCOUNT_LOGOUT',
    CONFIGURATION: 'ACCOUNT_CONFIGURATION',
    USER_CONFIGURATION: 'USER_CONFIGURATION',
    SET_JAILED: 'ACCOUNT_SET_JAILED'
  },

  SIGNUP: {
    SET_USER_ROLE: 'SIGN_UP_SET_USER_ROLE',
    SET_FORM_ERROR: 'SIGN_UP_SET_FORM_ERROR'
  },

  BOOK: {
    SET_BOOKS_DATA: 'BOOK_SET_BOOKS_DATA',
    SET_BOOK_INFO: 'BOOK_SET_BOOK_INFO',
    SET_OPEN_UNIT: 'BOOK_SET_OPEN_UNIT',
    SET_SELECTED_RESOURCE: 'BOOK_SET_SELECTED_RESOURCE',
    SET_NEW_LESSON_UNIT: 'SET_NEW_LESSON_UNIT',
    SET_SELECTED_UNIT: 'BOOK_SET_SELECTED_UNIT',
    SET_OPEN_NEW_UNIT: 'BOOK_SET_OPEN_NEW_UNIT',
    SET_ACTIVITY_DELETE_DATA: 'SET_ACTIVITY_DELETE_DATA',
    SET_UNIT_EDITION: 'BOOK_SET_UNIT_EDITION',
    SET_REMOVE_BOOK_INFO: 'SET_REMOVE_BOOK_INFO',
    SET_RE_DOWNLOAD_BOOK_INFO: 'SET_RE_DOWNLOAD_BOOK_INFO',
    SET_IS_LINK_LESSON_MODAL_OPEN: 'SET_IS_LINK_LESSON_MODAL_OPEN',
    SET_IS_AUTO_EXEC_MODAL_OPEN: 'SET_IS_AUTO_EXEC_MODAL_OPEN',
    SET_SYNCHRONIZED_CLASSROOMS: 'SET_SYNCHRONIZED_CLASSROOMS',
    SET_DESYNCHRONIZE_ACTIVITY_CONTEXT: 'SET_DESYNCHRONIZE_ACTIVITY_CONTEXT',
    SET_ACTIVITY_LINK_CHANGED: 'SET_ACTIVITY_LINK_CHANGED',
    SET_UPLOAD_CONTENT_STATUS: 'SET_UPLOAD_CONTENT_STATUS',
    SET_COPY_REVEAL: 'SET_COPY_REVEAL',
    SET_NEW_LESSON_UNIT_ID: 'SET_NEW_LESSON_UNIT_ID'
  },

  CLASSROOM: {
    SET_ACTIVE_CLASSROOM_DATA: 'CLASSROOM_SET_ACTIVE_CLASSROOM_DATA',
    SET_ARCHIVED_CLASSROOM_DATA: 'CLASSROOM_SET_ARCHIVED_CLASSROOM_DATA',
    SET_ADD_MODAL_STATE: 'CLASSROOM_SET_ADD_MODAL_STATE',
    SET_ENROLL_MODAL_STATE: 'CLASSROOM_SET_ENROLL_MODAL_STATE',
    SET_SUBMIT_TASK_DATA_STATE: 'SET_SUBMIT_TASK_DATA_STATE',
    SEND_SUBMIT_TASK_DATA_STATE: 'SEND_SUBMIT_TASK_DATA_STATE',
    SET_EDIT_ROLE_MODAL_STATE: 'SET_EDIT_ROLE_MODAL_STATE',
    SET_NOT_CAN_UPLOAD_FILES: 'SET_NOT_CAN_UPLOAD_FILES',
    SET_UNENROLL_MODAL_STATE: 'CLASSROOM_SET_UNENROLL_MODAL_STATE',
    SET_ARCHIVE_MODAL_STATE: 'CLASSROOM_SET_ARCHIVE_MODAL_STATE',
    SET_ARCHIVE_MODAL_DATA: 'CLASSROOM_SET_ARCHIVE_MODAL_DATA',
    SET_TASKS_ATTEMPTS: 'SEL_CLASSROOM_SET_TASKS_ATTEMPTS',
    SET_IMPORT_MODAL_STATE: 'CLASSROOM_SET_IMPORT_MODAL_STATE',
    SET_FAIL_IMPORT_MODAL_STATE: 'CLASSROOM_SET_FAIL_IMPORT_MODAL_STATE',
    SET_FAIL_IMPORT_STUDENTS_ERRORS: 'CLASSROOM_SET_FAIL_IMPORT_STUDENTS_ERRORS',
    SET_CSV_FILE_UPLOADED: 'CLASSROOM_SET_CSV_FILE_UPLOADED',
    FETCH_ACTIVE_CLASSROOMS: 'CLASSROOM_FETCH_ACTIVE_CLASSROOMS',
    FETCH_CURRENT_CLASSROOM: 'CLASSROOM_FETCH_CURRENT_CLASSROOM',
    FETCHING: 'CLASSROOM_FETCHING',
    FETCHING_PARTICIPANTS: 'FETCHING_CLASSROOM_PARTCIPANTS',
    SET_ACTIVE_TAB: 'PARTICIPANTS_SET_ACTIVE_TAB'
  },

  BASIC_ANALYTICS: {
    SET_BASIC_ANALYTICS_DATA: 'SET_BASIC_ANALYTICS_DATA',
    SET_BASIC_ANALYTICS_DATE: 'SET_BASIC_ANALYTICS_DATE',
    SET_SELECTED_STUDENTS: 'SET_SELECTED_STUDENTS'
  },

  CONTENT: {
    SET_CONTENT_BOOK: 'SET_CONTENT_BOOK',
    SET_CONTENT_SYNCHRONIZATION: 'SET_CONTENT_SYNCHRONIZATION',
    SET_CDN_SYNCRHONIZATION: 'SET_CDN_SYNCRHONIZATION',
    SET_CONTENT_SYNCHRONIZATION_DATE: 'SET_CONTENT_SYNCHRONIZATION_DATE',
    SET_ACTIVITY_CONTENT: 'SET_ACTIVITY_CONTENT'
  },

  COMPONENTS: {
    FETCHING: 'COMPONENTS_REQUEST_FETCHING',
    SET_DROP_DOWN_OPEN: 'COMPONENTS_SET_DROP_DOWN_OPEN',
    PREVIOUS_ROUTE: 'COMPONENTS_PREVIOUS_ROUTE',
    SET_MENU_OPEN: 'COMPONENTS_SET_MENU_OPEN',
    SET_ACTIVE_LOADER: 'COMPONENTS_SET_ACTIVE_LOADER'
  },

  SEL_CLASSROOM: {
    SET_CLASSROOM_INFO: 'SEL_CLASSROOM_SET_CLASSROOM_INFO',
    SET_CLASSROOM_PARTICIPANTS: 'SEL_CLASSROOM_SET_CLASSROOM_PARTICIPANTS',
    SET_CLASSROOM_GROUPS: 'SEL_CLASSROOM_SET_CLASSROOM_GROUPS',
    SET_CLASSCODE_POPUP_STATE: 'SEL_CLASSROOM_SET_CLASSCODE_POPUP_STATE',
    SET_VIDEOCALL_INFO: 'SEL_CLASSROOM_SET_VIDEOCALL_INFO'
  },

  STUDENT: {
    SET_SELECTED_PROFILE: 'STUDENT_SET_SELECTED_PROFILE'
  },

  SEL_GROUP: {
    SET_SELECTED_GROUP: 'SEL_GROUP_SET_SELECTED_GROUP'
  },

  GROUP: {
    SET_ADD_GROUP_IS_OPEN: 'SET_ADD_GROUP_IS_OPEN',
    SET_REMOVE_GROUP_IS_OPEN: 'SET_REMOVE_GROUP_IS_OPEN',
    SET_GROUP_TO_REMOVE: 'SET_GROUP_TO_REMOVE',
    SET_EDIT_GROUP_IS_OPEN: 'SET_EDIT_GROUP_IS_OPEN',
    SET_GROUP_TO_EDIT: 'SET_GROUP_TO_EDIT',
    SET_PICTOGRAM_CONFIG: 'SET_PICTOGRAM_CONFIG'
  },

  MESSAGE: {
    SET_INFO_MESSAGES: 'MESSAGE_SET_INFO_MESSAGES',
    SET_ERROR_MESSAGES: 'MESSAGE_SET_ERROR_MESSAGES',
    SET_SUCCESS_MESSAGES: 'MESSAGE_SET_SUCCESS_MESSAGES',
    SET_WARNING_MESSAGES: 'MESSAGE_SET_WARNING_MESSAGES'
  },

  REVEAL: {
    OPEN_PINS_REVEAL: 'REVEAL_OPEN_PINS_REVEAL',
    CLOSE_PINS_REVEAL: 'REVEAL_CLOSE_PINS_REVEAL',
    SET_OPENED_REVEAL: 'REVEAL_SET_OPENED_REVEAL',
    OPEN_DISABLE_EVALUATIONS_REVEAL: 'REVEAL_OPEN_DISABLE_EVALUATIONS_REVEAL',
    OPEN_DISABLE_COMMENT_REVEAL: 'REVEAL_OPEN_DISABLE_COMMENT_REVEAL',
    CLOSE_DISABLE_EVALUATIONS_REVEAL: 'REVEAL_CLOSE_DISABLE_EVALUATIONS_REVEAL',
    DISABLE_EVALUATIONS_REVEAL: 'REVEAL_DISABLE_EVALUATIONS_REVEAL',
    OPEN_STUDENTS_WITH_FILES_REVEAL: 'OPEN_STUDENTS_WITH_FILES_REVEAL',
    CLOSE_STUDENTS_WITH_FILES_REVEAL: 'CLOSE_STUDENTS_WITH_FILES_REVEAL',
    STUDENTS_WITH_FILES_CONFIRMATION: 'STUDENTS_WITH_FILES_CONFIRMATION',
    OPEN_STUDENTS_WITHOUT_ASSIGNMENT_IN_LESSONS: 'OPEN_STUDENTS_WITHOUT_ASSIGNMENT_IN_LESSONS',
    OPEN_TASK_WITHOUT_STUDENTS_OF_THIS_GROUP: 'OPEN_TASK_WITHOUT_STUDENTS_OF_THIS_GROUP',
    SET_CUSTOM_CONFIRM_MODAL_OPENED: 'SET_CUSTOM_CONFIRM_MODAL_OPENED',
    SET_LINKED_BOOK_MODAL_OPENED: 'SET_LINKED_BOOK_MODAL_OPENED'
  },

  ROUTE: {
    SET_IN_CLASSROOM: 'ROUTER_SET_IN_CLASSROOM',
    SET_IN_BOOK: 'ROUTER_SET_IN_BOOK',
    SET_IN_PROFILE: 'ROUTER_SET_IN_PROFILE',
    SET_INDEX_TRANSITION: 'ROUTER_SET_INDEX_TRANSITION',
    SET_APP_LOCATION: 'ROUTER_SET_APP_LOCATION',
    SET_APP_HISTORY: 'SET_APP_HISTORY',
    SET_APP_PARAMS: 'SET_APP_PARAMS',
    SET_REDIRECT_AFTER_LOGIN: 'SET_REDIRECT_AFTER_LOGIN',
    CLEAR_REDIRECT_AFTER_LOGIN: 'CLEAR_REDIRECT_AFTER_LOGIN'
  },

  SCHOOL: {
    SET_SCHOOL_DATA: 'SCHOOL_SET_SCHOOL_DATA',
    SET_SCHOOL_INFO: 'SCHOOL_SET_SCHOOL_INFO',
    SET_LOADED_SCHOOL_INFO: 'SET_LOADED_SCHOOL_INFO'
  },

  SECTION: {
    SET_MY_CLASSES: 'SECTION_SET_MY_CLASSES',
    SET_DEFAULT: 'SECTION_SET_DEFAULT'
  },

  TASK: {
    SET_TASK_DATA: 'TASK_SET_TASK_DATA',
    SET_TASKS: 'TASK_SET_TASKS',
    SET_CURRENT_TASKS: 'TASK_SET_CURRENT_TASKS',
    SET_CURRENT_TASKS_PAGES: 'TASK_SET_CURRENT_TASKS_PAGES',
    SET_CURRENT_TASKS_CURRENT_PAGE: 'TASK_SET_CURRENT_TASKS_CURRENT_PAGE',
    SET_CURRENT_TASKS_FETCHING: 'TASK_SET_CURRENT_TASKS_FETCHING',
    SET_FINISHED_TASKS: 'TASK_SET_FINISHED_TASKS',
    SET_FINISHED_TASKS_PAGES: 'TASK_SET_FINISHED_TASKS_PAGES',
    SET_FINISHED_TASKS_CURRENT_PAGE: 'TASK_SET_FINISHED_TASKS_CURRENT_PAGE',
    SET_FINISHED_TASKS_FETCHING: 'TASK_SET_FINISHED_TASKS_FETCHING',
    SET_FUTURE_TASKS: 'TASK_SET_FUTURE_TASKS',
    SET_FUTURE_TASKS_PAGES: 'TASK_SET_FUTURE_TASKS_PAGES',
    SET_FUTURE_TASKS_CURRENT_PAGE: 'TASK_SET_FUTURE_TASKS_CURRENT_PAGE',
    SET_FUTURE_TASKS_FETCHING: 'TASK_SET_FUTURE_TASKS_FETCHING',
    SET_FILTERED_TASKS: 'TASK_SET_FILTERED_TASKS',
    SET_FILTERED_TASKS_PAGES: 'TASK_SET_FILTERED_TASKS_PAGES',
    SET_FILTERED_TASKS_CURRENT_PAGE: 'TASK_SET_FILTERED_TASKS_CURRENT_PAGE',
    SET_FILTERED_TASKS_FETCHING: 'TASK_SET_FILTERED_TASKS_FETCHING',
    SET_DATE_RANGE_TASKS_FILTER: 'TASK_SET_DATE_RANGE_TASKS_FILTER',
    SET_KEYWORDS_TASKS_FILTER: 'TASK_SET_KEYWORDS_TASKS_FILTER',
    SET_SELECTED_TASK: 'TASK_SET_SELECTED_TASK',
    SET_STUDENTS_ASSIGNED: 'TASK_SET_STUDENTS_ASSIGNED',
    SET_MODAL_OPEN_TASK: 'TASK_SET_MODAL_OPEN_TASK',
    SET_EVALUATED_ASSIGNMENT_COMMENTS: 'SET_EVALUATED_ASSIGNMENT_COMMENTS',
    SET_TASK_RESPONSE_COMMENTS: 'SET_TASK_RESPONSE_COMMENTS',
    SET_ACTIVE_TAB: 'TASK_SET_ACTIVE_TAB',
    SET_CONTENT_NOT_FOUND: 'TASK_SET_CONTENT_NOT_FOUND',
    SET_PARTICIPANTS_DRAWER: 'SET_PARTICIPANTS_DRAWER',
    SET_ACTIVATE_STATE: 'SET_ACTIVATE_STATE',
    SET_UPLOAD_TASK_STATUS: 'SET_UPLOAD_TASK_STATUS'
  },

  DISCUSSION: {
    SET_CURRENT_DISCUSSIONS: 'DISCUSSION_SET_CURRENT_DISCUSSIONS',
    SET_CURRENT_DISCUSSIONS_PAGES: 'DISCUSSION_SET_CURRENT_DISCUSSIONS_PAGES',
    SET_CURRENT_DISCUSSIONS_CURRENT_PAGE: 'DISCUSSION_SET_CURRENT_DISCUSSIONS_CURRENT_PAGE',
    SET_CURRENT_DISCUSSIONS_FETCHING: 'DISCUSSION_SET_CURRENT_DISCUSSIONS_FETCHING',
    SET_FINISHED_DISCUSSIONS: 'DISCUSSION_SET_FINISHED_DISCUSSIONS',
    SET_FINISHED_DISCUSSIONS_PAGES: 'DISCUSSION_SET_FINISHED_DISCUSSIONS_PAGES',
    SET_FINISHED_DISCUSSIONS_CURRENT_PAGE: 'DISCUSSION_SET_FINISHED_DISCUSSIONS_CURRENT_PAGE',
    SET_FINISHED_DISCUSSIONS_FETCHING: 'DISCUSSION_SET_FINISHED_DISCUSSIONS_FETCHING',
    SET_FUTURE_DISCUSSIONS: 'DISCUSSION_SET_FUTURE_DISCUSSIONS',
    SET_FUTURE_DISCUSSIONS_PAGES: 'DISCUSSION_SET_FUTURE_DISCUSSIONS_PAGES',
    SET_FUTURE_DISCUSSIONS_CURRENT_PAGE: 'DISCUSSION_SET_FUTURE_DISCUSSIONS_CURRENT_PAGE',
    SET_FUTURE_DISCUSSIONS_FETCHING: 'DISCUSSION_SET_FUTURE_DISCUSSIONS_FETCHING',
    SET_SELECTED_DISCUSSION: 'DISCUSSION_SET_SELECTED_DISCUSSION',
    SET_SELECTED_DISCUSSION_FETCHING: 'DISCUSSION_SET_SELECTED_DISCUSSION_FETCHING',
    SET_SELECTED_DISCUSSION_MESSAGES: 'DISCUSSION_SET_SELECTED_DISCUSSION_MESSAGES',
    SET_SELECTED_DISCUSSION_MESSAGES_ORDER: 'DISCUSSION_SET_SELECTED_DISCUSSION_MESSAGES_ORDER',
    SET_SELECTED_DISCUSSION_MESSAGES_PAGES: 'DISCUSSION_SET_SELECTED_DISCUSSION_MESSAGES_PAGES',
    SET_SELECTED_DISCUSSION_MESSAGES_CURRENT_PAGE: 'DISCUSSION_SET_SELECTED_DISCUSSION_MESSAGES_CURRENT_PAGE',
    SET_SELECTED_DISCUSSION_MESSAGES_FETCHING: 'DISCUSSION_SET_SELECTED_DISCUSSION_MESSAGES_FETCHING',
    SET_ACTIVE_TAB: 'DISCUSSION_SET_ACTIVE_TAB',
    SET_REMOVE_MODAL_OPEN: 'DISCUSSION_SET_REMOVE_MODAL_OPEN',
    SET_REMOVE_MODAL_DATA: 'DISCUSSION_SET_REMOVE_MODAL_DATA',
    SET_CLOSE_MODAL_OPEN: 'DISCUSSION_SET_CLOSE_MODAL_OPEN',
    SET_CLOSE_MODAL_DATA: 'DISCUSSION_SET_CLOSE_MODAL_DATA'
  },

  CONNECTION: {
    STATUS: 'CONNECTION_STATUS',
    STATUS_RABBIT: 'CONNECTION_STATUS_RABBIT',
    STATUS_RABBIT_STATE: 'CONNECTION_STATUS_RABBIT_STATE',
    STATUS_NETWORK: 'CONNECTION_NETWORK',
    TRYING: 'CONNECTION_TRYING',
    ATTEMPTS: 'CONNECTION_ATTEMPTS',
    IS_LOADING_DATA: 'CONNECTION_IS_LOADING_DATA'
  },

  DRAWER: {
    OPEN: 'DRAWER_DRAWER_OPEN',
    CLOSE: 'DRAWER_DRAWER_CLOSE',
    SET_CONTENT: 'DRAWER_DRAWER_SET_CONTENT'
  },

  GOOGLE_CLASSROOM: {
    SET_COURSE_ID: 'SET_COURSE_ID',
    CLEAR_COURSE_ID: 'CLEAR_COURSE_ID',
    SET_CONTENT: 'SET_CONTENT',
    CLEAR_CONTENT: 'CLEAR_CONTENT'
  },

  ASSIGNMENT_DRAWER: {
    SET_EVALUATED_STUDENT: 'TASK_SET_EVALUATED_STUDENT',
    SET_SELECTED_GROUP: 'DATE_BOX_SET_SELECTED_GROUP',
    ON_CHECKED_ACTIVITIES_CHANGE: 'ASSIGNMENT_DRAWER_ON_CHECKBOX_CHANGE',
    SET_ACTIVITIES: 'ASSIGNMENT_DRAWER_DATE_BOX_SET_LESSONS',
    SET_FETCHING_BOOKS_ACTIVITIES: 'SET_FETCHING_BOOKS_ACTIVITIES',
    SET_RESPONSE_FILE: 'ASSIGNMENT_DRAWER_SET_RESPONSE_FILE',
    SET_DESCRIPTION_TASK: 'ASSIGNMENT_DRAWER_SET_DESCRIPTION_TASK',
    SET_TITLE_TASK: 'ASSIGNMENT_DRAWER_SET_TITLE_TASK',
    SET_ALLOW_FILE: 'ASSIGNMENT_SET_ALLOW_FILE',
    SET_ALLOW_USER_COMMENT_RESPONSE: 'ASSIGNMENT_SET_ALLOW_USER_COMMENT_RESPONSE',
    SET_DUE_DATE: 'ASSIGNMENT_DRAWER_SET_DUE_DATE',
    SET_START_DATE: 'ASSIGNMENT_DRAWER_SET_START_DATE',
    SET_UPLOAD_DRAWER_FILE_STATUS: 'SET_UPLOAD_DRAWER_FILE_STATUS'
  },

  DISCUSSION_DRAWER: {
    TOGGLE_MODAL: 'DISCUSSION_DRAWER_TOGGLE_MODAL',
    SET_DEAD_LINE: 'DISCUSSION_DRAWER_SET_DEAD_LINE',
    SET_START_DATE: 'DISCUSSION_DRAWER_SET_START_DATE',
    SET_SELECTED_GROUP: 'DISCUSSION_DRAWER_SET_SELECTED_GROUP',
    SET_DESCRIPTION: 'DISCUSSION_DRAWER_SET_DESCRIPTION',
    SET_TITLE: 'DISCUSSION_DRAWER_SET_TITLE',
    SET_MODE: 'DISCUSSION_DRAWER_SET_MODE',
    SET_DISCUSSION_ID: 'DISCUSSION_DRAWER_SET_DISCUSSION_ID'
  },

  LIBRARY: {
    SET_CLOSED_FILTERS: 'LIBRARY_SET_CLOSED_FILTERS',
    SET_PRIMARY_BOOKS: 'LIBRARY_SET_PRIMARY_BOOKS',
    SET_FILTERED_BOOKS: 'LIBRARY_SET_FILTERED_BOOKS',
    REQUEST_FILTERED_BOOKS: 'LIBRARY_REQUEST_FILTERED_BOOKS',
    SET_CURRENT_FILTERS: 'LIBRARY_SET_CURRENT_FILTERS',
    SET_FILTERS: 'LIBRARY_SET_FILTERS',
    SET_OPEN_PREVIEW: 'LIBRARY_SET_OPEN_PREVIEW',
    SET_FETCHING_PREVIEW: 'LIBRARY_SET_FETCHING_PREVIEW',
    SET_IMPORT_REVEAL: 'SET_IMPORT_REVEAL',
    SET_IMPORT_VINCULATION_REVEAL: 'SET_IMPORT_VINCULATION_REVEAL',
    SET_IMPORT_IS_FETCHING: 'SET_IMPORT_IS_FETCHING',
    SET_IMPORT_FINISHED_REVEAL: 'SET_IMPORT_FINISHED_REVEAL',
    SET_PAGINATOR: 'LIBRARY_SET_PAGINATOR',
    REMOVE_TAG: 'REMOVE_TAG',
    REMOVE_TAGS: 'REMOVE_TAGS',
    REMOVE_SEARCH_CONFIG: 'REMOVE_SEARCH_CONFIG',
    ADD_TAG: 'ADD_TAG',
    ADD_UNIT_ID: 'ADD_UNIT_ID',
    REMOVE_UNIT_ID: 'REMOVE_UNIT_ID',
    REMOVE_ALL_UNIT_ID: 'REMOVE_ALL_UNIT_ID'
  },
  GRADEBOOK: {
    SET_GRADES: 'GRADEBOOK_SET_GRADES',
    SET_BOOKS_DATA: 'GRADEBOOK_SET_BOOKS_DATA',
    SET_GRADEBOOK_SCOPE: 'SET_GRADEBOOK_SCOPE',
    SET_UNITS_DATA: 'GRADEBOOK_SET_UNITS_DATA',
    SET_LESSONS_DATA: 'GRADEBOOK_SET_LESSONS_DATA',
    SET_ACTIVITIES_DATA: 'GRADEBOOK_SET_ACTIVITIES_DATA',
    SET_SELECTED_BOOK: 'GRADEBOOK_SET_SELECTED_BOOK',
    SET_SELECTED_LESSON: 'GRADEBOOK_SET_SELECTED_LESSON',
    SET_SELECTED_UNIT: 'GRADEBOOK_SET_SELECTED_UNIT',
    SET_TASKS_DATA: 'SET_TASKS_DATA',
    SET_TASKS_FILTER_PARAMS: 'SET_TASKS_FILTER_PARAMS'
  },

  THEME: {
    SET_THEME: 'SET_THEME',
    LOADED_THEME: 'LOADED_THEME',
    SKIN_URL: 'SKIN_URL'
  },

  ERROR: {
    SET_CODE: 'SET_ERROR_CODE',
    SET_DESCRIPTION: 'SET_ERROR_DESCRIPTION'
  },

  SEARCH: {
    SEARCH_RESULTS: 'SEARCH_RESULTS',
    CONTEXT: 'SEARCH_CONTEXT',
    MODE: 'SEARCH_MODE'
  },

  COOKIES: {
    TOGGLE_MEET_COOKIE: 'TOGGLE_MEET_COOKIE'
  },

  GUEST: {
    IS_FETCHING: 'GUEST_IS_FETCHING',
    SET_RESOLVED_CLIENT: 'GUEST_SET_RESOLVED_CLIENT',
    SET_CODE_ERROR: 'GUEST_SET_CODE_ERROR',
    SET_SESSION: 'GUEST_SET_SESSION',
    SET_SESSION_EXPIRED_MODAL: 'GUEST_SET_SESSION_EXPIRED_MODAL',
    CLEAR_SESSION: 'GUEST_CLEAR_SESSION'
  }
};
